<div class="main-policy-container" style="margin: 50px;">
    <h4>Política de Privacidad</h4>
    <h5>Aplicación SGI 4.0</h5>

    <p><strong>EFICACIA S.A.</strong></p>
    <p><strong>Última actualización:</strong> Abril de 2026</p>

    <p>
        En EFICACIA S.A. valoramos tu privacidad y tratamos tus datos personales con responsabilidad,
        transparencia y medidas de seguridad razonables. Esta Política de Privacidad explica qué información
        puede recopilar la aplicación SGI 4.0, con qué finalidad se utiliza, en qué casos puede compartirse y
        cuáles son tus derechos como titular de la información.
    </p>

    <p>
        SGI 4.0 es una aplicación de uso laboral orientada a la gestión de actividades en campo, seguimiento
        operativo, registro de evidencias y control de tareas asignadas por la empresa que contrata el servicio.
    </p>

    <section>
        <h5>1. Responsable del tratamiento de datos</h5>
        <p><strong>Empresa:</strong> EFICACIA S.A.</p>
        <p><strong>Aplicación:</strong> SGI 4.0</p>
        <p><strong>Correo general de contacto:</strong> info@eficacia.com.co, diy.eficacia@gmail.com</p>
        <p><strong>Sitio web:</strong> www.eficacia.com.co</p>
        <p>
            EFICACIA S.A. actúa como responsable o encargado del tratamiento de los datos personales, según
            corresponda, dentro del marco de la prestación del servicio y de la relación existente con la empresa
            cliente que utiliza la plataforma.
        </p>
    </section>

    <section>
        <h5>2. Alcance de esta política</h5>
        <p>
            Esta política aplica al tratamiento de datos personales realizado a través de la aplicación móvil
            SGI 4.0, así como a los procesos relacionados con su operación, soporte, almacenamiento, seguridad y
            administración.
        </p>
        <p>
            El uso de la aplicación implica el tratamiento de ciertos datos personales y técnicos estrictamente
            necesarios para prestar las funcionalidades ofrecidas por SGI 4.0.
        </p>
    </section>

    <section>
        <h5>3. Qué información podemos recopilar</h5>
        <p>
            SGI 4.0 puede recopilar y tratar las siguientes categorías de información, según las funciones
            habilitadas para tu perfil y el uso que hagas de la app:
        </p>

        <h5>3.1. Datos de identificación y contacto</h5>
        <p>Podemos tratar datos como:</p>
        <ul>
            <li>nombre y apellidos,</li>
            <li>correo electrónico,</li>
            <li>número de teléfono,</li>
            <li>dirección,</li>
            <li>empresa, cargo o información asociada a tu vinculación laboral.</li>
        </ul>
        <p>
            Estos datos permiten identificar al usuario dentro del sistema, asignar actividades, registrar
            evidencias y mantener trazabilidad de las operaciones realizadas.
        </p>

        <h5>3.2. Datos de ubicación</h5>
        <p>La app puede acceder a tu ubicación:</p>
        <ul>
            <li>cuando la aplicación está en uso,</li>
            <li>
                y, en ciertos casos, cuando la app se encuentra en segundo plano o cerrada, si esa
                funcionalidad está habilitada y resulta necesaria para procesos como registro automático de
                asistencia, validación de presencia en zonas asignadas o trazabilidad de rutas laborales.
            </li>
        </ul>
        <p>
            La recopilación de ubicación se limita a finalidades operativas relacionadas con el servicio
            prestado por SGI 4.0.
        </p>

        <h5>3.3. Actividad dentro de la aplicación</h5>
        <p>Podemos registrar información relacionada con el uso de la app, incluyendo:</p>
        <ul>
            <li>inicios y cierres de sesión,</li>
            <li>fechas y horas de uso,</li>
            <li>actividades ejecutadas,</li>
            <li>formularios diligenciados,</li>
            <li>evidencias cargadas,</li>
            <li>interacciones necesarias para la operación del sistema.</li>
        </ul>

        <h5>3.4. Información técnica del dispositivo</h5>
        <p>
            Podemos recopilar información técnica básica del equipo utilizado para acceder a la app, por ejemplo:
        </p>
        <ul>
            <li>modelo del dispositivo,</li>
            <li>sistema operativo y versión,</li>
            <li>identificadores técnicos necesarios para soporte, seguridad, diagnóstico y correcto funcionamiento.</li>
        </ul>

        <h5>3.5. Evidencias y contenido generado por el usuario</h5>
        <p>Dependiendo de las funcionalidades habilitadas, la app puede permitir capturar o cargar:</p>
        <ul>
            <li>fotografías,</li>
            <li>audios,</li>
            <li>información escaneada mediante cámara,</li>
            <li>otras evidencias asociadas a la ejecución de actividades laborales.</li>
        </ul>
        <p>
            Este contenido solo se trata en la medida en que sea necesario para la operación del servicio.
        </p>
    </section>

    <section>
        <h5>4. Para qué usamos la información</h5>
        <p>
            La información tratada a través de SGI 4.0 se utiliza únicamente para finalidades legítimas,
            específicas y relacionadas con la operación de la plataforma. Entre ellas:
        </p>
        <ul>
            <li>autenticar y administrar el acceso de usuarios;</li>
            <li>registrar asistencia, ubicación operativa y cumplimiento de actividades;</li>
            <li>documentar rutas, visitas, formularios, reportes y evidencias;</li>
            <li>facilitar la supervisión y gestión operativa por parte de la empresa cliente;</li>
            <li>atender solicitudes de soporte técnico, diagnóstico y mejora del servicio;</li>
            <li>mantener seguridad, trazabilidad, auditoría y control de uso de la plataforma;</li>
            <li>cumplir obligaciones legales, regulatorias y contractuales aplicables.</li>
        </ul>
        <p>
            EFICACIA S.A. no utiliza los datos personales tratados por SGI 4.0 para fines de publicidad
            comportamental, venta de información o finalidades ajenas al servicio descrito en esta política.
        </p>
    </section>

    <section>
        <h5>5. Base legal para el tratamiento</h5>
        <p>
            El tratamiento de datos personales realizado a través de SGI 4.0 se fundamenta, según corresponda,
            en una o varias de las siguientes bases:
        </p>
        <ul>
            <li>la relación contractual existente entre EFICACIA S.A. y la empresa cliente que utiliza la plataforma;</li>
            <li>la ejecución de actividades propias de la relación laboral o de prestación de servicios del usuario con la empresa cliente;</li>
            <li>la autorización otorgada por el titular cuando esta resulte aplicable;</li>
            <li>el cumplimiento de obligaciones legales.</li>
        </ul>
        <p>
            Cuando la normativa lo requiera, se solicitará la autorización correspondiente para el tratamiento de
            determinados datos o para el acceso a permisos sensibles del dispositivo.
        </p>
    </section>

    <section>
        <h5>6. Permisos del dispositivo y cómo se usan</h5>
        <p>
            La aplicación puede solicitar permisos del dispositivo únicamente cuando son necesarios para
            habilitar funciones concretas.
        </p>

        <h5>6.1. Permiso de ubicación</h5>
        <p>SGI 4.0 puede solicitar acceso a la ubicación del dispositivo para funciones como:</p>
        <ul>
            <li>registro de asistencia,</li>
            <li>validación de presencia en puntos o zonas de trabajo,</li>
            <li>trazabilidad de recorridos o rutas operativas,</li>
            <li>soporte a procesos internos de supervisión y control laboral.</li>
        </ul>
        <p>
            La app mostrará previamente una
            explicación clara sobre la finalidad de ese permiso y su relación con la funcionalidad correspondiente.
        </p>

        <h5>6.2. Permiso de cámara</h5>
        <p>La cámara puede utilizarse para:</p>
        <ul>
            <li>captura de fotografías de evidencia,</li>
            <li>escaneo de códigos QR o códigos de barras,</li>
            <li>otras funciones que requieran captura visual iniciada por el usuario.</li>
        </ul>
        <p>La cámara no se activa automáticamente ni realiza capturas sin interacción del usuario.</p>

        <h5>6.3. Permiso de micrófono</h5>
        <p>El micrófono puede utilizarse para:</p>
        <ul>
            <li>grabación de evidencias en audio,</li>
            <li>funciones de comunicación o interacción por voz,</li>
            <li>otras funcionalidades expresamente activadas por el usuario.</li>
        </ul>
        <p>El micrófono no se utiliza para grabación oculta o permanente en segundo plano.</p>
    </section>

    <section>
        <h5>7. Con quién compartimos la información</h5>
        <p>Los datos personales tratados a través de SGI 4.0 podrán ser compartidos únicamente en los siguientes casos:</p>
        <ul>
            <li>con la empresa cliente o empleador que administra el uso de la plataforma dentro de su operación;</li>
            <li>con proveedores tecnológicos que apoyan el alojamiento, soporte, mantenimiento, almacenamiento, seguridad o procesamiento de la información, bajo obligaciones de confidencialidad y seguridad;</li>
            <li>con autoridades judiciales, administrativas o regulatorias, cuando exista obligación legal o requerimiento formal.</li>
        </ul>
        <p>EFICACIA S.A. no vende datos personales ni los comparte con terceros para fines publicitarios.</p>
    </section>

    <section>
        <h5>8. Dónde se almacena la información y por cuánto tiempo</h5>
        <p>
            La información se almacena en entornos tecnológicos administrados por EFICACIA S.A. o por
            proveedores autorizados que prestan servicios de infraestructura, almacenamiento, procesamiento o
            respaldo.
        </p>
        <p>Los datos se conservarán durante el tiempo necesario para:</p>
        <ul>
            <li>cumplir las finalidades descritas en esta política,</li>
            <li>atender obligaciones contractuales,</li>
            <li>responder requerimientos legales o regulatorios,</li>
            <li>soportar procesos de auditoría, seguridad y trazabilidad.</li>
        </ul>
        <p>
            Cuando la información deje de ser necesaria para estas finalidades, será eliminada, anonimizada o
            suprimida conforme a las políticas internas aplicables y a los tiempos exigidos por la ley o por la
            relación contractual vigente.
        </p>
    </section>

    <section>
        <h5>9. Medidas de seguridad</h5>
        <p>
            EFICACIA S.A. adopta medidas de seguridad razonables de carácter administrativo, técnico y
            organizacional para proteger la información contra acceso no autorizado, pérdida, alteración, uso
            indebido o divulgación no permitida.
        </p>
        <p>Estas medidas pueden incluir, entre otras:</p>
        <ul>
            <li>controles de acceso;</li>
            <li>autenticación y gestión de permisos;</li>
            <li>cifrado en tránsito y otras medidas de protección de comunicaciones;</li>
            <li>respaldos y mecanismos de recuperación;</li>
            <li>trazabilidad y auditoría de operaciones;</li>
            <li>restricciones de acceso al personal autorizado.</li>
        </ul>
        <p>
            Aunque se aplican medidas razonables de seguridad, ningún sistema es completamente infalible. Por
            ello, la protección de la información también requiere un uso responsable de credenciales,
            dispositivos y accesos por parte de cada usuario.
        </p>
    </section>

    <section>
        <h5>10. Derechos del titular de los datos</h5>
        <p>
            Como titular de tus datos personales, puedes ejercer los derechos que te reconoce la normativa
            aplicable, entre ellos:
        </p>
        <ul>
            <li>conocer qué datos personales tratamos sobre ti;</li>
            <li>solicitar actualización o corrección de información inexacta;</li>
            <li>solicitar prueba de la autorización cuando aplique;</li>
            <li>presentar consultas o reclamos sobre el tratamiento de tus datos;</li>
            <li>solicitar la supresión de tus datos cuando proceda legalmente;</li>
            <li>revocar la autorización cuando resulte aplicable y no exista deber legal o contractual que impida el tratamiento.</li>
        </ul>
        <p>Para ejercer estos derechos puedes escribir a: diy.eficacia@gmail.com</p>
        <p>
            EFICACIA S.A. atenderá las consultas y reclamos dentro de los términos previstos por la normativa
            aplicable.
        </p>
    </section>

    <section>
        <h5>11. Gestión de cuentas, desactivación y eliminación de datos</h5>
        <p>
            El acceso a SGI 4.0 puede depender de la vinculación del usuario con la empresa cliente que
            administra la plataforma. En consecuencia:
        </p>
        <ul>
            <li>la activación, suspensión o desactivación de la cuenta puede estar sujeta a la gestión realizada por la empresa cliente;</li>
            <li>las solicitudes de eliminación de cuenta o supresión de datos serán evaluadas conforme a la relación contractual, las obligaciones legales, los requerimientos de trazabilidad y las finalidades legítimas del servicio;</li>
            <li>cuando legal y contractualmente sea procedente, EFICACIA S.A. gestionará la eliminación, anonimización o supresión de la información correspondiente.</li>
        </ul>
        <p>
            Si deseas realizar una solicitud relacionada con eliminación de datos o desactivación de cuenta,
            puedes contactarnos a través de los canales indicados en esta política.
        </p>
    </section>

    <section>
        <h5>12. Control de permisos desde el dispositivo</h5>
        <p>
            El usuario puede revisar o modificar los permisos concedidos a SGI 4.0 desde la configuración del
            dispositivo móvil.
        </p>
        <p>
            Ten en cuenta que, si desactivas determinados permisos, algunas funcionalidades de la app pueden
            dejar de estar disponibles o funcionar de forma limitada. Por ejemplo:
        </p>
        <ul>
            <li>sin permiso de ubicación, ciertas funciones de asistencia, validación o trazabilidad podrían no operar correctamente;</li>
            <li>sin cámara, no será posible capturar determinadas evidencias o escanear códigos;</li>
            <li>sin micrófono, no podrán usarse funciones que dependan de audio o interacción por voz.</li>
        </ul>
    </section>

    <section>
        <h5>13. Menores de edad</h5>
        <p>
            SGI 4.0 es una aplicación diseñada para uso laboral y no está dirigida a menores de edad. No
            buscamos recopilar intencionalmente información de menores. Si detectamos que se ha registrado
            información de un menor sin la debida autorización o sin base legítima para ello, adoptaremos las
            medidas correspondientes para bloquear el acceso y gestionar la eliminación de los datos cuando
            proceda.
        </p>
    </section>

    <section>
        <h5>14. Cambios a esta política</h5>
        <p>
            EFICACIA S.A. podrá actualizar esta Política de Privacidad cuando sea necesario por cambios
            normativos, operativos, tecnológicos o de negocio.
        </p>
        <p>Cuando los cambios sean relevantes, podremos informar a los usuarios por medios razonables, como:</p>
        <ul>
            <li>notificaciones dentro de la app,</li>
            <li>comunicación a través del correo registrado,</li>
            <li>actualización de la fecha de vigencia publicada en esta política.</li>
        </ul>
        <p>
            El uso continuado de la aplicación después de la entrada en vigor de los cambios implicará el
            entendimiento de que el usuario conoce la versión vigente de esta política, sin perjuicio de los
            derechos que la ley le reconoce.
        </p>
    </section>

    <section>
        <h5>15. Marco normativo de referencia</h5>
        <p>
            Esta política se interpreta y aplica conforme a la normativa aplicable en materia de protección de
            datos personales y a las condiciones de operación de la plataforma, incluyendo, entre otras
            disposiciones que resulten aplicables:
        </p>
        <ul>
            <li>Ley 1581 de 2012;</li>
            <li>Decreto 1377 de 2013;</li>
            <li>demás normas colombianas aplicables sobre protección de datos personales;</li>
            <li>lineamientos y requisitos de plataformas de distribución digital cuando resulten aplicables al funcionamiento y publicación de la app.</li>
        </ul>
    </section>

    <section>
        <h5>16. Contacto</h5>
        <p>
            Si tienes preguntas, consultas o reclamos relacionados con esta Política de Privacidad o con el
            tratamiento de tus datos personales, puedes comunicarte con nosotros a través de:
        </p>
        <p><strong>Correo general:</strong> info@eficacia.com.co</p>
        <p><strong>Sitio web:</strong> www.eficacia.com.co</p>
        <p>EFICACIA S.A. – SGI 4.0</p>
    </section>
</div>
